import React from "react";
import Nav from "../containers/Nav";
import BiobankContainer from "../containers/BiobankContainer";
import {useTranslation} from "react-i18next";

const Biobank = () => {
    const {t} = useTranslation()
    return (
        <div className="App">
            <Nav/>
            <BiobankContainer/>
        </div>
    );
}
export default Biobank;